// // ManageGroupEmployee.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import SuccessImg from "../../../Assets/Images/CommanImages/Informative.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";

// /**
//  * ManageGroupEmployee
//  * - loads members using get-user-group-members-by-id and sends default_group_flag numeric 1/0
//  * - prevents searching/removal/saving when default group
//  * - enables Save only when user makes changes (add/remove)
//  * - hides ID column and shows employee name as plain text (no hyperlink)
//  */
// function ManageGroupEmployee({ dataClient, setMessageBox, setIsMessageBoxVisible, setActiveImg }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const accessToken = localStorage.getItem("other");

//   // --- read-only group fields (UI) ---
//   const [studentGroupName, setStudentGroupName] = useState("");
//   const [studentGroupDesc, setStudentGroupDesc] = useState("");
//   const [messageFlag, setMessageFlag] = useState("");
//   const [emailFlag, setEmailFlag] = useState("");
//   const [createdBy, setCreatedBy] = useState("");
//   const [groupOwnerName, setGroupOwnerName] = useState("");
//   const [lastModifiedBy, setLastModifiedBy] = useState("");
//   const [defaultUserGroup, setDefaultUserGroup] = useState("");
//   const [status, setStatus] = useState("");
//   const [comments, setComments] = useState("");

//   // reviewer fields
//   const [isReviewerGroup, setIsReviewerGroup] = useState("");
//   const [reviewCourseName, setReviewCourseName] = useState("");
//   const [reviewCourseId, setReviewCourseId] = useState("");
//   const [reviewSubjectName, setReviewSubjectName] = useState("");
//   const [reviewSubjectId, setReviewSubjectId] = useState("");
//   const [reviewerGroupType, setReviewerGroupType] = useState("");
//   const [facultyReviewLevel, setFacultyReviewLevel] = useState("");

//   // client/branch + logged user
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//   const clientBranchIdFromClient = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const clientBranchNum = clientBranchIdFromClient ? Number(clientBranchIdFromClient) : null;

//   // member dropdown and table state
//   const [memberOptions, setMemberOptions] = useState([]); // { label, id, fullData }
//   const [selectedMembers, setSelectedMembers] = useState([]); // array of ids

//   // loaded ids & flags
//   const [loadedUserGroupId, setLoadedUserGroupId] = useState(null);
//   const [loadedClientId, setLoadedClientId] = useState(null);
//   const [isDefaultGroup, setIsDefaultGroup] = useState(false);

//   // snapshot to detect changes
//   const initialSelectedMembersRef = useRef([]);
//   const [isDirty, setIsDirty] = useState(false);

//   // location/state helpers from dashboard
//   const passedHeaders = location.state?.headers ?? [];
//   const passedRowRaw = (() => {
//     if (Array.isArray(location.state?.selectedRowsData) && location.state.selectedRowsData.length > 0) {
//       return location.state.selectedRowsData[0];
//     }
//     if (Array.isArray(location.state?.rowData) && location.state.rowData.length > 0) {
//       return location.state.rowData;
//     }
//     return location.state?.rowData ?? [];
//   })();

//   // find header index robustly (strip t*/n*/d* prefix, case-insensitive)
//   const headerIndexOf = (name) => {
//     if (!Array.isArray(passedHeaders) || passedHeaders.length === 0) return -1;
//     let idx = passedHeaders.findIndex((h) => String(h).trim() === name);
//     if (idx !== -1) return idx;
//     idx = passedHeaders.findIndex((h) => String(h).replace(/^[a-z]\*/, "").trim() === name);
//     if (idx !== -1) return idx;
//     idx = passedHeaders.findIndex((h) => String(h).replace(/^[a-z]\*/, "").trim().toLowerCase() === name.toLowerCase());
//     if (idx !== -1) return idx;
//     idx = passedHeaders.findIndex((h) => String(h).toLowerCase().includes(name.toLowerCase()));
//     return idx;
//   };

//   const getValueFromPassedRow = (name) => {
//     const idx = headerIndexOf(name);
//     if (idx === -1) return "";
//     const val = passedRowRaw[idx];
//     return val === null || val === undefined ? "" : val;
//   };

//   const findValueFromAny = (names) => {
//     for (const n of names) {
//       const v = getValueFromPassedRow(n);
//       if (v !== "") return v;
//       const q = new URLSearchParams(location.search || "").get(n) ?? new URLSearchParams(location.search || "").get(n.replace(/\s+/g, ""));
//       if (q) return q;
//     }
//     return "";
//   };

//   const parseDefaultFlag = (raw) => {
//     if (raw === true || raw === 1 || raw === "1" || raw === "True" || raw === "true" || raw === "TRUE" || String(raw).toLowerCase() === "yes") return true;
//     return false;
//   };

//   // Initialize UI fields and compute loaded ids & flags
//   useEffect(() => {
//     setStudentGroupName(findValueFromAny(["User Group Name", "UserGroupName", "t*User Group Name"]));
//     setStudentGroupDesc(findValueFromAny(["User Group Description", "UserGroupDescription", "t*User Group Description"]));
//     setMessageFlag(findValueFromAny(["Message Flag", "MessageFlag", "t*Message Flag"]));
//     setEmailFlag(findValueFromAny(["Email Flag", "EmailFlag", "t*Email Flag"]));
//     setCreatedBy(findValueFromAny(["Created By", "CreatedBy", "t*Created By"]));
//     setGroupOwnerName(findValueFromAny(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"]));
//     setLastModifiedBy(findValueFromAny(["Last Modified By", "LastModifiedBy", "t*Last Modified By", "Last Modified Date"]));
//     setDefaultUserGroup(findValueFromAny(["Default Group", "DefaultUserGroup", "t*Default Group", "default_group_flag"]));
//     setStatus(findValueFromAny(["Status", "t*Status"]));
//     setComments(findValueFromAny(["Comments", "t*Comments"]));

//     // setIsReviewerGroup(findValueFromAny(["Ques Reviewer Group ID", "QuesReviewerGroupID", "n*Ques Reviewer Group ID"]) ? "Yes" : "");
//     const reviewerGroupIdVal = findValueFromAny(["Ques Reviewer Group ID", "QuesReviewerGroupID", "n*Ques Reviewer Group ID"]);
//     reviewerGroupIdVal == "NA" || reviewerGroupIdVal === "" ? setIsReviewerGroup("No") : setIsReviewerGroup("Yes");

//     setReviewCourseName(findValueFromAny(["Course Name", "CourseName", "t*Course Name"]));
//     setReviewCourseId(findValueFromAny(["Course ID", "CourseID", "n*Course ID"]));
//     setReviewSubjectName(findValueFromAny(["Subject Name", "SubjectName", "t*Subject Name"]));
//     setReviewSubjectId(findValueFromAny(["Subject ID", "SubjectID", "n*Subject ID"]));
//     setReviewerGroupType(findValueFromAny(["Reviewer Group Type", "ReviewerGroupType", "t*Reviewer Group Type"]));
//     const lvl = findValueFromAny(["Faculty Review Level", "FacultyReviewLevel", "n*Faculty Review Level"]);
//     setFacultyReviewLevel(lvl ? String(lvl) : "");

//     // explicit flags from location.state
//     const explicitDefault = location.state?.default_group_flag ?? location.state?.default_group ?? location.state?.defaultGroup;
//     const explicitClient = location.state?.client_branch_id ?? location.state?.client_branchid ?? location.state?.clientBranchId ?? location.state?.client_id;

//     let computedDefaultBool = false;
//     if (explicitDefault !== undefined) {
//       computedDefaultBool = parseDefaultFlag(explicitDefault);
//     } else {
//       const rawDefaultFromRow = findValueFromAny(["Default Group", "default_group_flag", "t*Default Group"]);
//       computedDefaultBool = parseDefaultFlag(rawDefaultFromRow);
//     }

//     let computedClient = null;
//     if (explicitClient !== undefined && explicitClient !== null && explicitClient !== "") {
//       computedClient = explicitClient;
//     } else {
//       const rawClientFromRow = findValueFromAny(["Client Branch ID", "client_branch_id", "t*Client Branch ID"]);
//       computedClient = rawClientFromRow || clientBranchNum || null;
//     }

//     const explicitUserGroupId = location.state?.user_group_id ?? location.state?.userGroupId ?? location.state?.user_groupid;
//     let computedUid = explicitUserGroupId ?? null;
//     if (!computedUid) {
//       const rawUid = findValueFromAny(["User Group ID", "user_group_id", "n*User Group ID"]);
//       computedUid = rawUid !== "" ? Number(rawUid) : null;
//     }

//     setLoadedUserGroupId(computedUid);
//     setLoadedClientId(computedClient !== null ? Number(computedClient) : computedClient);
//     setIsDefaultGroup(Boolean(computedDefaultBool));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [location.state]);

//   // Helper mapping server member objects -> dropdown option
//   const mapMembersToOptions = (membersArray) => {
//     const arr = Array.isArray(membersArray) ? membersArray : [];
//     return arr.map((m, idx) => {
//       const fullData = m || {};
//       const displayName = fullData.employee_name || fullData.emp_name || fullData.user_name || `Member ${idx + 1}`;
//       const roll = fullData.staff_number || fullData.staff_no || fullData.roll_number || "";
//       const branch = fullData.branch_name || fullData.batch_name || "";
//       const id = fullData.employee_id ?? fullData.emp_id ?? fullData.user_id ?? fullData.id ?? `${idx}`;
//       return {
//         label: `${displayName}${roll ? ` (${roll})` : ""}${branch ? " - " + branch : ""}`,
//         id,
//         fullData,
//       };
//     });
//   };

//   // Fetch members by id, ALWAYS send default_group_flag numeric 1 or 0
//   const fetchGroupMembers = async (userGroupId, clientId = null, defaultFlagNumeric = 0) => {
//     if (!userGroupId) {
//       setMemberOptions([]);
//       setSelectedMembers([]);
//       initialSelectedMembersRef.current = [];
//       setIsDirty(false);
//       return;
//     }

//     try {
//       const params = new URLSearchParams();
//       params.append("user_group_id", String(userGroupId));
//       params.append("default_group_flag", String(defaultFlagNumeric)); // 1 or 0
//       if (clientId !== null && clientId !== undefined && clientId !== "") params.append("client_branch_id", String(clientId));

//       const res = await fetch(`${FULL_API_BASE_URL}/get-user-group-members-by-id?${params.toString()}`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       const json = await res.json();
//       if (json && json.status === 200 && Array.isArray(json.data)) {
//         const opts = mapMembersToOptions(json.data);
//         setMemberOptions(opts);
//         const ids = opts.map((o) => o.id);
//         setSelectedMembers(ids);
//         initialSelectedMembersRef.current = ids.slice(); // snapshot for dirty check
//         setIsDirty(false);
//       } else {
//         setMemberOptions([]);
//         setSelectedMembers([]);
//         initialSelectedMembersRef.current = [];
//         setIsDirty(false);
//       }
//     } catch (err) {
//       console.error("Error fetching group members:", err);
//       setMemberOptions([]);
//       setSelectedMembers([]);
//       initialSelectedMembersRef.current = [];
//       setIsDirty(false);
//     }
//   };

//   // fetch on load and when defaults change
//   useEffect(() => {
//     if (!loadedUserGroupId) {
//       setMemberOptions([]);
//       setSelectedMembers([]);
//       initialSelectedMembersRef.current = [];
//       setIsDirty(false);
//       return;
//     }
//     const flag = isDefaultGroup ? 1 : 0;
//     const clientToSend = loadedClientId ?? clientBranchNum ?? null;
//     fetchGroupMembers(loadedUserGroupId, clientToSend, flag);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loadedUserGroupId, isDefaultGroup, loadedClientId]);

//   // Search employees for dropdown: NOOP when default group (disabled)
//   const fetchEmployeesForGroupSearch = (searchKey) => {
//     if (isDefaultGroup) return;
//     if (!searchKey) return;

//     const params = new URLSearchParams();
//     params.append("search_key", searchKey);
//     const clientToSend = loadedClientId || clientBranchNum || null;
//     if (clientToSend) params.append("client_branch_id", String(clientToSend));
//     fetch(`${FULL_API_BASE_URL}/search-emp-for-group?${params.toString()}`, {
//       headers: { Authorization: `Bearer ${accessToken}` },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         const arr = Array.isArray(data.data) ? data.data : [];
//         const newOpts = arr.map((s) => ({
//           label: `${s.employee_name || s.user_name || "Unknown"}${s.staff_number ? ` (${s.staff_number})` : ""}${s.branch_name ? " - " + s.branch_name : ""}`,
//           id: s.employee_id ?? s.emp_id ?? s.user_id ?? s.id,
//           fullData: s,
//         }));

//         // Put the freshly searched results first, then add any previous options that are not duplicates.
//         setMemberOptions((prev = []) => {
//           const map = new Map();
//           newOpts.forEach((n) => map.set(String(n.id), n));
//           prev.forEach((p) => {
//             if (!map.has(String(p.id))) map.set(String(p.id), p);
//           });
//           return Array.from(map.values());
//         });
//       })
//       .catch((err) => {
//         console.error("Error fetching employees:", err);
//       });
//   };

//   // Build table data in the shape TableWithCrossStudentGroup expects (array of arrays)
//   // we keep row[0] = id (used internally), but we will hide that column in the table component
//   const tableData = (Array.isArray(selectedMembers) ? selectedMembers : [])
//     .map((id) => {
//       const opt = memberOptions.find((o) => String(o.id) === String(id));
//       if (!opt || !opt.fullData) {
//         // keep id at index 0 for internal logic
//         return [id, "---", "---", "NA", "NA", "---", "---"];
//       }
//       const s = opt.fullData;
//       return [
//         id,
//         s.employee_name || s.emp_name || s.user_name || "---",
//         s.staff_number || s.staff_no || s.roll_number || "---",
//         s.designation_name || s.designation || "NA",
//         s.department_name || s.department || "NA",
//         s.user_name || s.userName || "---",
//         s.branch_name || s.center_name || "---",
//       ];
//     })
//     .filter(Boolean);

//   // detect modifications (dirty)
//   useEffect(() => {
//     // compare arrays (order-insensitive)
//     const initial = (initialSelectedMembersRef.current || []).map(String).sort();
//     const now = (selectedMembers || []).map(String).sort();
//     const changed = initial.length !== now.length || initial.some((v, i) => v !== now[i]);
//     setIsDirty(changed);
//   }, [selectedMembers]);

//   // table selection event
//   const handleTableRowSelection = (newSelectedRows) => {
//     setSelectedMembers(newSelectedRows);
//   };

//   // delete (remove) handler — guarded: NOOP when default group
//   const handleDeleteRow = (rowId) => {
//     if (isDefaultGroup) return; // do not allow removal in default mode
//     setMemberOptions((prev) => (prev || []).filter((o) => String(o.id) !== String(rowId)));
//     setSelectedMembers((prev) => (prev || []).filter((id) => String(id) !== String(rowId)));
//   };

//   // Build members payload for update-user-group-members API
//   const buildMembersPayload = () => {
//     return (selectedMembers || []).map((id) => {
//       const opt = memberOptions.find((o) => String(o.id) === String(id));
//       const fd = opt?.fullData || {};
//       const empId = fd.employee_id ?? fd.emp_id ?? fd.student_id ?? fd.id ?? null;
//       const userId = fd.user_id ?? fd.userId ?? null;
//       return {
//         emp_id: empId,
//         user_id: userId !== undefined ? userId : null,
//         comments: `updated by ${userName || "unknown"}`,
//       };
//     });
//   };

//   // Save (PUT) — guard: don't run when default group, only when dirty
//   const handleSave = async () => {
//     if (isDefaultGroup) {
//       console.warn("Attempted save while in default group mode — ignored.");
//       return;
//     }
//     if (!isDirty) {
//       // nothing changed
//       return;
//     }
//     if (!loadedUserGroupId) {
//       console.error("No user_group_id available for update.");
//       return;
//     }

//     const payload = {
//       user_group_id: loadedUserGroupId,
//       user_name: userName || "",
//       client_id: loadedClientId ?? clientBranchNum ?? 0,
//       members: buildMembersPayload(),
//     };

//     try {
//       const res = await fetch(`${FULL_API_BASE_URL}/update-user-group-members`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${accessToken}`,
//         },
//         body: JSON.stringify(payload),
//       });
//       const json = await res.json();
//       if (json && (json.status === 200 || json.status === "success" || res.status === 200)) {
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Members updated successfully.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(SuccessImg);
//           setIsMessageBoxVisible(true);
//           setTimeout(() => setIsMessageBoxVisible(false), 2000);
//         }
//         // refresh members after update
//         fetchGroupMembers(loadedUserGroupId, loadedClientId ?? clientBranchNum ?? null, isDefaultGroup ? 1 : 0);
//       } else {
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc error"></div>
//                 <span>Failed to update members.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(ErrorImg);
//           setIsMessageBoxVisible(true);
//           setTimeout(() => setIsMessageBoxVisible(false), 2000);
//         }
//       }
//     } catch (err) {
//       console.error("Error updating members:", err);
//       if (setMessageBox) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc error"></div>
//               <span>Failed to update members (network error).</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => setIsMessageBoxVisible(false), 2000);
//       }
//     }
//   };

//   // table headers we pass into TableWithCrossStudentGroup
//   // NOTE: We keep id internally at row[0], but we will hide the ID column in the table component.
//   const tableHeaders = ["ID", "Employee Name", "Staff Number", "Designation", "Department", "User Name", "Branch"];

//   // ---------- New: locked when group inactive ----------
//   const groupsLocked = !!status && String(status).toLowerCase() === "inactive";
//   // content dim style — copy same feel as user information (opacity + slight white tint)
//   const manageEmployeeContentStyle = groupsLocked
//     ? { opacity: 0.45, pointerEvents: "none", backgroundColor: "rgba(255,255,255,0.5)" }
//     : {};

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         {/* <span className="create-role-heading">Manage Group Employee</span> */}
//         <span className="create-role-heading">Manage Group Member</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn" onClick={() => navigate("/user_groups_dashboard")}>
//             CANCEL
//           </button>

//           {/* Save disabled in DOM when default group OR not dirty OR group is locked */}
//           <button className="cr-create-btn" onClick={handleSave} disabled={isDefaultGroup || !isDirty || groupsLocked} style={{ opacity: isDefaultGroup || !isDirty || groupsLocked ? 0.45 : 1, cursor: isDefaultGroup || !isDirty || groupsLocked ? "not-allowed" : "pointer" }}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       {/* GROUP INFORMATION */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>GROUP INFROMATION</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 {/* <FormInputs label="User Group Name" type="text" required value={studentGroupName} disabled /> */}
//                 <FormInputs label="User Group Name" type="text" value={studentGroupName} disabled />
//               </div>

//               <div className="item2">
//                 {/* <FormInputs label="User Group Description" type="text" required value={studentGroupDesc} disabled /> */}
//                 <FormInputs label="User Group Description" type="text" value={studentGroupDesc} disabled />
//               </div>

//               <div className="item3">
//                 <FormInputs label="Message Enabled" value={messageFlag} disabled />
//               </div>

//               <div className="item4">
//                 <FormInputs label="Email Enabled" value={emailFlag} disabled />
//               </div>

//               <div className="item2">
//                 <FormInputs label="Created By" type="text" value={createdBy} disabled />
//               </div>

//               <div className="item5">
//                 <FormInputs label="Group Owner Name" value={groupOwnerName} disabled />
//               </div>

//               <div className="item2">
//                 <FormInputs label="Last Modified By" type="text" value={lastModifiedBy} disabled />
//               </div>

//               <div className="item2">
//                 <FormInputs label="Default Group" type="text" value={String(defaultUserGroup)} disabled />
//               </div>

//               <div className="item2">
//                 <FormInputs label="Status" type="text" value={status} disabled />
//               </div>

//               <div className="item6" style={{ gridColumn: "1 / -1" }}>
//                 <FormInputs label="Comments" type="text" value={comments} disabled />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* QUESTION REVIEWER GROUP */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>QUESTION REVIEWER GROUP</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs label="Is this a Question Reviewer Group?" type="text" value={isReviewerGroup} disabled />
//               </div>

//               <div className="item2">
//                 {/* <FormInputs label="Course" type="text" value={reviewCourseName || reviewCourseId} disabled /> */}
//                 <FormInputs
//                   label="Course"
//                   type="text"
//                   value={reviewCourseName == "NA" ? "" : reviewCourseName}
//                   disabled
//                 />
//               </div>

//               <div className="item3">
//                 {/* <FormInputs label="Subject" type="text" value={reviewSubjectName || reviewSubjectId} disabled /> */}
//                 <FormInputs
//                   label="Subject"
//                   type="text"
//                   value={reviewSubjectName == "NA" ? "" : reviewSubjectName}
//                   disabled
//                 />
//               </div>

//               <div className="item4">
//                 {/* <FormInputs label="HOD or Faculty Reviewer Group?" type="text" value={reviewerGroupType} disabled /> */}
//                 <FormInputs
//                   label="HOD or Faculty Reviewer Group?"
//                   type="text"
//                   value={reviewerGroupType == "NA" ? "" : reviewerGroupType}
//                   disabled
//                 />
//               </div>

//               <div className="item5">
//                 {/* <FormInputs label="Reviewer Level" type="text" value={facultyReviewLevel ? String(facultyReviewLevel) : ""} disabled /> */}
//                 <FormInputs
//                   label="Reviewer Level"
//                   type="text"
//                   value={
//                     facultyReviewLevel == "NA" || facultyReviewLevel == "0"
//                       ? ""
//                       : String(facultyReviewLevel)
//                   }
//                   disabled
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* MANAGE EMPLOYEE */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>MANAGE EMPLOYEE</label>
//           </div>
//         </div>

//         {/* CONTENT: header stays visible; content gets dimmed/disabled when group is inactive */}
//         <div className="accordion-content" style={groupsLocked ? { opacity: 1 } : {}}>
//           <div className="select-assign-test-container-ques-pap-del" style={{ padding: "20px 0px 20px 10px" }}>
//             <div className="grid-container-ques-paper-del">
//               <div className="item1" style={manageEmployeeContentStyle}>
//                 <DropdownWithPagination
//                   label="Add Employees"
//                   width="100%"
//                   selected={selectedMembers}
//                   setSelected={(vals) => {
//                     setSelectedMembers(vals);
//                   }}
//                   onSearchInputChange={fetchEmployeesForGroupSearch}
//                   options={memberOptions}
//                   // isRequired={true}
//                   showSelectAll={true}
//                   itemsPerPage={4}
//                   isDisabled={isDefaultGroup || groupsLocked} // disable when default or group locked
//                 />
//               </div>

//               <div style={{ gridColumn: "1 / -1", marginTop: 16, ...(groupsLocked ? { opacity: 0.45 } : {}) }}>
//                 <div style={groupsLocked ? { pointerEvents: "none" } : {}}>
//                   <TableWithCrossStudentGroup
//                     headers={tableHeaders}
//                     data={tableData}
//                     searchPlaceholder="Search employees..."
//                     selectedRows={selectedMembers}
//                     setSelectedRows={handleTableRowSelection}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteRow} // will be no-op when default
//                     isEditMode={!isDefaultGroup && !groupsLocked} // disable edits when default or locked
//                     hideIdColumn={true} // hide first id column visually
//                     disableHyperlink={true} // do not render the employee name as a hyperlink
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ManageGroupEmployee;

// ManageGroupEmployee.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import SuccessImg from "../../../Assets/Images/CommanImages/Informative.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";

/**
 * ManageGroupEmployee
 * - loads members using get-user-group-members-by-id and sends default_group_flag numeric 1/0
 * - prevents searching/removal/saving when default group
 * - enables Save only when user makes changes (add/remove)
 * - hides ID column and shows employee name as plain text (no hyperlink)
 */
function ManageGroupEmployee({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const accessToken = localStorage.getItem("other");

  // --- read-only group fields (UI) ---
  const [studentGroupName, setStudentGroupName] = useState("");
  const [studentGroupDesc, setStudentGroupDesc] = useState("");
  const [messageFlag, setMessageFlag] = useState("");
  const [emailFlag, setEmailFlag] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [groupOwnerName, setGroupOwnerName] = useState("");
  const [lastModifiedBy, setLastModifiedBy] = useState("");
  const [defaultUserGroup, setDefaultUserGroup] = useState("");
  const [status, setStatus] = useState("");
  const [comments, setComments] = useState("");

  // reviewer fields
  const [isReviewerGroup, setIsReviewerGroup] = useState("");
  const [reviewCourseName, setReviewCourseName] = useState("");
  const [reviewCourseId, setReviewCourseId] = useState("");
  const [reviewSubjectName, setReviewSubjectName] = useState("");
  const [reviewSubjectId, setReviewSubjectId] = useState("");
  const [reviewerGroupType, setReviewerGroupType] = useState("");
  const [facultyReviewLevel, setFacultyReviewLevel] = useState("");

  // client/branch + logged user
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
  const clientBranchIdFromClient =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const clientBranchNum = clientBranchIdFromClient
    ? Number(clientBranchIdFromClient)
    : null;

  // member dropdown and table state
  const [memberOptions, setMemberOptions] = useState([]); // { label, id, fullData }
  const [selectedMembers, setSelectedMembers] = useState([]); // array of ids

  // loaded ids & flags
  const [loadedUserGroupId, setLoadedUserGroupId] = useState(null);
  const [loadedClientId, setLoadedClientId] = useState(null);
  const [isDefaultGroup, setIsDefaultGroup] = useState(false);

  // snapshot to detect changes
  const initialSelectedMembersRef = useRef([]);
  const [isDirty, setIsDirty] = useState(false);

  // location/state helpers from dashboard
  const passedHeaders = location.state?.headers ?? [];
  const passedRowRaw = (() => {
    if (
      Array.isArray(location.state?.selectedRowsData) &&
      location.state.selectedRowsData.length > 0
    ) {
      return location.state.selectedRowsData[0];
    }
    if (
      Array.isArray(location.state?.rowData) &&
      location.state.rowData.length > 0
    ) {
      return location.state.rowData;
    }
    return location.state?.rowData ?? [];
  })();

  // find header index robustly (strip t*/n*/d* prefix, case-insensitive)
  const headerIndexOf = (name) => {
    if (!Array.isArray(passedHeaders) || passedHeaders.length === 0) return -1;
    let idx = passedHeaders.findIndex((h) => String(h).trim() === name);
    if (idx !== -1) return idx;
    idx = passedHeaders.findIndex(
      (h) =>
        String(h)
          .replace(/^[a-z]\*/, "")
          .trim() === name
    );
    if (idx !== -1) return idx;
    idx = passedHeaders.findIndex(
      (h) =>
        String(h)
          .replace(/^[a-z]\*/, "")
          .trim()
          .toLowerCase() === name.toLowerCase()
    );
    if (idx !== -1) return idx;
    idx = passedHeaders.findIndex((h) =>
      String(h).toLowerCase().includes(name.toLowerCase())
    );
    return idx;
  };

  const getValueFromPassedRow = (name) => {
    const idx = headerIndexOf(name);
    if (idx === -1) return "";
    const val = passedRowRaw[idx];
    return val === null || val === undefined ? "" : val;
  };

  const findValueFromAny = (names) => {
    for (const n of names) {
      const v = getValueFromPassedRow(n);
      if (v !== "") return v;
      const q =
        new URLSearchParams(location.search || "").get(n) ??
        new URLSearchParams(location.search || "").get(n.replace(/\s+/g, ""));
      if (q) return q;
    }
    return "";
  };

  const parseDefaultFlag = (raw) => {
    if (
      raw === true ||
      raw === 1 ||
      raw === "1" ||
      raw === "True" ||
      raw === "true" ||
      raw === "TRUE" ||
      String(raw).toLowerCase() === "yes"
    )
      return true;
    return false;
  };

  // Initialize UI fields and compute loaded ids & flags
  useEffect(() => {
    setStudentGroupName(
      findValueFromAny([
        "User Group Name",
        "UserGroupName",
        "t*User Group Name",
      ])
    );
    setStudentGroupDesc(
      findValueFromAny([
        "User Group Description",
        "UserGroupDescription",
        "t*User Group Description",
      ])
    );
    setMessageFlag(
      findValueFromAny(["Message Flag", "MessageFlag", "t*Message Flag"])
    );
    setEmailFlag(findValueFromAny(["Email Flag", "EmailFlag", "t*Email Flag"]));
    setCreatedBy(findValueFromAny(["Created By", "CreatedBy", "t*Created By"]));
    setGroupOwnerName(
      findValueFromAny([
        "Group Owner Name",
        "GroupOwnerName",
        "t*Group Owner Name",
      ])
    );
    setLastModifiedBy(
      findValueFromAny([
        "Last Modified By",
        "LastModifiedBy",
        "t*Last Modified By",
        "Last Modified Date",
      ])
    );
    setDefaultUserGroup(
      findValueFromAny([
        "Default Group",
        "DefaultUserGroup",
        "t*Default Group",
        "default_group_flag",
      ])
    );
    setStatus(findValueFromAny(["Status", "t*Status"]));
    setComments(findValueFromAny(["Comments", "t*Comments"]));

    // setIsReviewerGroup(findValueFromAny(["Ques Reviewer Group ID", "QuesReviewerGroupID", "n*Ques Reviewer Group ID"]) ? "Yes" : "");
    const reviewerGroupIdVal = findValueFromAny([
      "Ques Reviewer Group ID",
      "QuesReviewerGroupID",
      "n*Ques Reviewer Group ID",
    ]);
    reviewerGroupIdVal == "NA" || reviewerGroupIdVal === ""
      ? setIsReviewerGroup("No")
      : setIsReviewerGroup("Yes");

    setReviewCourseName(
      findValueFromAny(["Course Name", "CourseName", "t*Course Name"])
    );
    setReviewCourseId(
      findValueFromAny(["Course ID", "CourseID", "n*Course ID"])
    );
    setReviewSubjectName(
      findValueFromAny(["Subject Name", "SubjectName", "t*Subject Name"])
    );
    setReviewSubjectId(
      findValueFromAny(["Subject ID", "SubjectID", "n*Subject ID"])
    );
    setReviewerGroupType(
      findValueFromAny([
        "Reviewer Group Type",
        "ReviewerGroupType",
        "t*Reviewer Group Type",
      ])
    );
    const lvl = findValueFromAny([
      "Faculty Review Level",
      "FacultyReviewLevel",
      "n*Faculty Review Level",
    ]);
    setFacultyReviewLevel(lvl ? String(lvl) : "");

    // explicit flags from location.state
    const explicitDefault =
      location.state?.default_group_flag ??
      location.state?.default_group ??
      location.state?.defaultGroup;
    const explicitClient =
      location.state?.client_branch_id ??
      location.state?.client_branchid ??
      location.state?.clientBranchId ??
      location.state?.client_id;

    let computedDefaultBool = false;
    if (explicitDefault !== undefined) {
      computedDefaultBool = parseDefaultFlag(explicitDefault);
    } else {
      const rawDefaultFromRow = findValueFromAny([
        "Default Group",
        "default_group_flag",
        "t*Default Group",
      ]);
      computedDefaultBool = parseDefaultFlag(rawDefaultFromRow);
    }

    let computedClient = null;
    if (
      explicitClient !== undefined &&
      explicitClient !== null &&
      explicitClient !== ""
    ) {
      computedClient = explicitClient;
    } else {
      const rawClientFromRow = findValueFromAny([
        "Client Branch ID",
        "client_branch_id",
        "t*Client Branch ID",
      ]);
      computedClient = rawClientFromRow || clientBranchNum || null;
    }

    const explicitUserGroupId =
      location.state?.user_group_id ??
      location.state?.userGroupId ??
      location.state?.user_groupid;
    let computedUid = explicitUserGroupId ?? null;
    if (!computedUid) {
      const rawUid = findValueFromAny([
        "User Group ID",
        "user_group_id",
        "n*User Group ID",
      ]);
      computedUid = rawUid !== "" ? Number(rawUid) : null;
    }

    setLoadedUserGroupId(computedUid);
    setLoadedClientId(
      computedClient !== null ? Number(computedClient) : computedClient
    );
    setIsDefaultGroup(Boolean(computedDefaultBool));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  // Helper mapping server member objects -> dropdown option
  const mapMembersToOptions = (membersArray) => {
    const arr = Array.isArray(membersArray) ? membersArray : [];
    return arr.map((m, idx) => {
      const fullData = m || {};
      // prefer server-provided "employee_name" if present, otherwise build from parts
      const displayName =
        fullData.employee_name && String(fullData.employee_name).trim() !== ""
          ? fullData.employee_name
          : [
              fullData.emp_last_name,
              fullData.emp_first_name,
              fullData.emp_middle_name,
            ]
              .filter(Boolean)
              .join(", ") || // try "Last, First Middle"
            [
              fullData.emp_first_name,
              fullData.emp_middle_name,
              fullData.emp_last_name,
            ]
              .filter(Boolean)
              .join(" ") ||
            fullData.user_name ||
            `Member ${idx + 1}`;

      const staff =
        fullData.staff_number ?? fullData.staff_no ?? fullData.staff ?? "";
      const branch = fullData.branch_name ?? fullData.center_name ?? "";
      // ensure id is emp_id if available (this matches previous behavior)
      const id =
        fullData.employee_id ??
        fullData.emp_id ??
        fullData.user_id ??
        fullData.id ??
        `${idx}`;
      return {
        label: `${displayName}${staff ? ` (${staff})` : ""}${
          branch ? " - " + branch : ""
        }`,
        id,
        fullData,
      };
    });
  };

  // Fetch members by id, ALWAYS send default_group_flag numeric 1 or 0
  const fetchGroupMembers = async (
    userGroupId,
    clientId = null,
    defaultFlagNumeric = 0
  ) => {
    if (!userGroupId) {
      setMemberOptions([]);
      setSelectedMembers([]);
      initialSelectedMembersRef.current = [];
      setIsDirty(false);
      return;
    }

    try {
      const params = new URLSearchParams();
      params.append("user_group_id", String(userGroupId));
      params.append("default_group_flag", String(defaultFlagNumeric)); // 1 or 0
      // if (clientId !== null && clientId !== undefined && clientId !== "") params.append("client_branch_id", String(clientId));

      const res = await fetch(
        `${FULL_API_BASE_URL}/get-user-group-members-by-id?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      const json = await res.json();
      if (json && json.status === 200 && Array.isArray(json.data)) {
        const opts = mapMembersToOptions(json.data);
        setMemberOptions(opts);
        const ids = opts.map((o) => o.id);
        setSelectedMembers(ids);
        initialSelectedMembersRef.current = ids.slice(); // snapshot for dirty check
        setIsDirty(false);
      } else {
        // fallback: if the endpoint returns array directly (rare here) handle it too
        if (Array.isArray(json)) {
          const opts = mapMembersToOptions(json);
          setMemberOptions(opts);
          const ids = opts.map((o) => o.id);
          setSelectedMembers(ids);
          initialSelectedMembersRef.current = ids.slice();
          setIsDirty(false);
        } else {
          setMemberOptions([]);
          setSelectedMembers([]);
          initialSelectedMembersRef.current = [];
          setIsDirty(false);
        }
      }
    } catch (err) {
      console.error("Error fetching group members:", err);
      setMemberOptions([]);
      setSelectedMembers([]);
      initialSelectedMembersRef.current = [];
      setIsDirty(false);
    }
  };

  // fetch on load and when defaults change
  useEffect(() => {
    if (!loadedUserGroupId) {
      setMemberOptions([]);
      setSelectedMembers([]);
      initialSelectedMembersRef.current = [];
      setIsDirty(false);
      return;
    }
    const flag = isDefaultGroup ? 1 : 0;
    const clientToSend = loadedClientId ?? clientBranchNum ?? null;
    fetchGroupMembers(loadedUserGroupId, clientToSend, flag);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedUserGroupId, isDefaultGroup, loadedClientId]);

  // -------------------------
  // SEARCH: use get-employee-by-search-key (handles the array shape you provided)
  // -------------------------
  const fetchEmployeesForGroupSearch = (searchKey) => {
    if (isDefaultGroup) return;
    if (!searchKey || String(searchKey).trim() === "") return;

    const params = new URLSearchParams();
    params.append("search_key", searchKey);
    const clientToSend = loadedClientId || clientBranchNum || null;
    if (clientToSend) params.append("client_branch_id", String(clientToSend));

    fetch(
      `${FULL_API_BASE_URL}/get-employee-by-search-key/?${params.toString()}`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    )
      .then((res) => res.json())
      .then((json) => {
        // Response can be an array (raw) or { data: [...] } or different shapes.
        // The API examples you gave show a plain array of objects (with emp_id, staff_number, emp_first_name...)
        // so we handle both possibilities.
        const arr = Array.isArray(json)
          ? json
          : Array.isArray(json?.data)
          ? json.data
          : [];

        const newOpts = arr.map((s, idx) => {
          // prefer server's employee_name if present, otherwise build from name parts
          const name =
            s.employee_name && String(s.employee_name).trim() !== ""
              ? s.employee_name
              : [s.emp_last_name, s.emp_first_name, s.emp_middle_name]
                  .filter(Boolean)
                  .join(", ") ||
                [s.emp_first_name, s.emp_middle_name, s.emp_last_name]
                  .filter(Boolean)
                  .join(" ") ||
                s.user_name ||
                `${s.emp_first_name || ""} ${s.emp_middle_name || ""} ${
                  s.emp_last_name || ""
                }`.trim() ||
                "Unknown";

          const staffNum = s.staff_number ?? s.staff_no ?? s.staff ?? "";
          const branch = s.branch_name ?? s.center_name ?? "";
          // keep emp_id as identifier when present
          const id =
            s.emp_id ??
            s.employee_id ??
            s.user_id ??
            s.employeeId ??
            `${s.emp_id ?? idx}`;

          return {
            id,
            label: `${name}${staffNum ? ` (${staffNum})` : ""}${
              branch ? " - " + branch : ""
            }`,
            fullData: s,
          };
        });

        // Merge: put new results first, then append previous non-duplicates (preserve any currently selected entries)
        setMemberOptions((prev = []) => {
          const map = new Map();
          newOpts.forEach((n) => map.set(String(n.id), n));
          prev.forEach((p) => {
            if (!map.has(String(p.id))) map.set(String(p.id), p);
          });
          // Ensure currently selected members remain available even if not returned in this search
          (selectedMembers || []).forEach((selId) => {
            const key = String(selId);
            if (!map.has(key)) {
              const foundInPrev = prev.find((p) => String(p.id) === key);
              if (foundInPrev) map.set(key, foundInPrev);
              else {
                // placeholder option for selected id (minimal)
                map.set(key, {
                  id: selId,
                  label: `Member ${selId}`,
                  fullData: { emp_id: selId },
                });
              }
            }
          });
          return Array.from(map.values());
        });
      })
      .catch((err) => {
        console.error(
          "Error fetching employees (get-employee-by-search-key):",
          err
        );
        // keep previous options on error
      });
  };

  // Build table data in the shape TableWithCrossStudentGroup expects (array of arrays)
  // we keep row[0] = id (used internally), but we will hide that column in the table component
  const tableData = (Array.isArray(selectedMembers) ? selectedMembers : [])
    .map((id) => {
      const opt = memberOptions.find((o) => String(o.id) === String(id));
      if (!opt || !opt.fullData) {
        // keep id at index 0 for internal logic
        return [id, "---", "---", "NA", "NA", "---", "---"];
      }
      const s = opt.fullData;
      // The GET-members API returns different names (employee_name, employee_id, staff_no),
      // while search returns emp_first_name/emp_last_name, etc. Normalize when building rows:
      const displayName =
        s.employee_name ||
        [s.emp_last_name, s.emp_first_name, s.emp_middle_name]
          .filter(Boolean)
          .join(", ") ||
        [s.emp_first_name, s.emp_middle_name, s.emp_last_name]
          .filter(Boolean)
          .join(" ") ||
        s.user_name ||
        "---";
      const staff = s.staff_no || s.staff_number || s.staff || "---";
      const designation = s.designation || s.designation_name || "NA";
      const department = s.department || s.department_name || "NA";
      const userNameVal = s.user_name || s.userName || "---";
      const branch = s.branch_name || s.center_name || s.branch || "---";

      return [
        id,
        displayName,
        staff,
        designation,
        department,
        userNameVal,
        branch,
      ];
    })
    .filter(Boolean);

  // detect modifications (dirty)
  useEffect(() => {
    // compare arrays (order-insensitive)
    const initial = (initialSelectedMembersRef.current || [])
      .map(String)
      .sort();
    const now = (selectedMembers || []).map(String).sort();
    const changed =
      initial.length !== now.length || initial.some((v, i) => v !== now[i]);
    setIsDirty(changed);
  }, [selectedMembers]);

  // table selection event
  const handleTableRowSelection = (newSelectedRows) => {
    setSelectedMembers(newSelectedRows);
  };

  // delete (remove) handler — guarded: NOOP when default group
  const handleDeleteRow = (rowId) => {
    if (isDefaultGroup) return; // do not allow removal in default mode
    setMemberOptions((prev) =>
      (prev || []).filter((o) => String(o.id) !== String(rowId))
    );
    setSelectedMembers((prev) =>
      (prev || []).filter((id) => String(id) !== String(rowId))
    );
  };

  // Build members payload for update-user-group-members API
  const buildMembersPayload = () => {
    return (selectedMembers || []).map((id) => {
      const opt = memberOptions.find((o) => String(o.id) === String(id));
      const fd = opt?.fullData || {};
      const empId =
        fd.employee_id ?? fd.emp_id ?? fd.employeeId ?? fd.id ?? null;
      const userId = fd.user_id ?? fd.userId ?? null;
      return {
        emp_id: empId,
        user_id: userId !== undefined ? userId : null,
        comments: `updated by ${userName || "unknown"}`,
      };
    });
  };

  // Save (PUT) — guard: don't run when default group, only when dirty
  const handleSave = async () => {
    if (isDefaultGroup) {
      console.warn("Attempted save while in default group mode — ignored.");
      return;
    }
    if (!isDirty) {
      // nothing changed
      return;
    }
    if (!loadedUserGroupId) {
      console.error("No user_group_id available for update.");
      return;
    }

    const payload = {
      user_group_id: loadedUserGroupId,
      user_name: userName || "",
      client_id: loadedClientId ?? clientBranchNum ?? 0,
      members: buildMembersPayload(),
    };

    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/update-user-group-members`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const json = await res.json();
      if (
        json &&
        (json.status === 200 || json.status === "success" || res.status === 200)
      ) {
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Members updated successfully.</span>
              </div>
            </div>
          );
          setActiveImg(SuccessImg);
          setIsMessageBoxVisible(true);
          setTimeout(() => setIsMessageBoxVisible(false), 2000);
        }
        // refresh members after update
        fetchGroupMembers(
          loadedUserGroupId,
          loadedClientId ?? clientBranchNum ?? null,
          isDefaultGroup ? 1 : 0
        );
      } else {
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc error"></div>
                <span>Failed to update members.</span>
              </div>
            </div>
          );
          setActiveImg(ErrorImg);
          setIsMessageBoxVisible(true);
          setTimeout(() => setIsMessageBoxVisible(false), 2000);
        }
      }
    } catch (err) {
      console.error("Error updating members:", err);
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc error"></div>
              <span>Failed to update members (network error).</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        setTimeout(() => setIsMessageBoxVisible(false), 2000);
      }
    }
  };

  // table headers we pass into TableWithCrossStudentGroup
  // NOTE: We keep id internally at row[0], but we will hide the ID column in the table component.
  const tableHeaders = [
    "ID",
    "Employee Name",
    "Staff Number",
    "Designation",
    "Department",
    "User Name",
    "Branch",
  ];

  // ---------- New: locked when group inactive ----------
  const groupsLocked = !!status && String(status).toLowerCase() === "inactive";
  // content dim style — copy same feel as user information (opacity + slight white tint)
  const manageEmployeeContentStyle = groupsLocked
    ? {
        opacity: 0.45,
        pointerEvents: "none",
        backgroundColor: "rgba(255,255,255,0.5)",
      }
    : { marginLeft: "20px" };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        {/* <span className="create-role-heading">Manage Group Employee</span> */}
        <span className="create-role-heading">Manage Group Member</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => navigate("/user_groups_dashboard")}
          >
            CANCEL
          </button>

          {/* Save disabled in DOM when default group OR not dirty OR group is locked */}
          <button
            className="cr-create-btn"
            onClick={handleSave}
            disabled={isDefaultGroup || !isDirty || groupsLocked}
            style={{
              opacity: isDefaultGroup || !isDirty || groupsLocked ? 0.45 : 1,
              cursor:
                isDefaultGroup || !isDirty || groupsLocked
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            SAVE
          </button>
        </div>
      </div>

      {/* GROUP INFORMATION */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>GROUP INFROMATION</label>
          </div>
        </div>

        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div className="item1">
                <FormInputs
                  label="User Group Name"
                  type="text"
                  value={studentGroupName}
                  disabled
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="User Group Description"
                  type="text"
                  value={studentGroupDesc}
                  disabled
                />
              </div>

              <div className="item3">
                <FormInputs
                  label="Message Enabled"
                  value={messageFlag}
                  disabled
                />
              </div>

              <div className="item4">
                <FormInputs label="Email Enabled" value={emailFlag} disabled />
              </div>

              <div className="item2">
                <FormInputs
                  label="Created By"
                  type="text"
                  value={createdBy}
                  disabled
                />
              </div>

              <div className="item5">
                <FormInputs
                  label="Group Owner Name"
                  value={groupOwnerName}
                  disabled
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="Last Modified By"
                  type="text"
                  value={lastModifiedBy}
                  disabled
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="Default Group"
                  type="text"
                  value={String(defaultUserGroup)}
                  disabled
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="Status"
                  type="text"
                  value={status}
                  disabled
                />
              </div>

              <div className="item6" style={{ gridColumn: "1 / -1" }}>
                <FormInputs
                  label="Comments"
                  type="text"
                  value={comments}
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* QUESTION REVIEWER GROUP */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION REVIEWER GROUP</label>
          </div>
        </div>

        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div className="item1">
                <FormInputs
                  label="Is this a Question Reviewer Group?"
                  type="text"
                  value={isReviewerGroup}
                  disabled
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="Course"
                  type="text"
                  value={reviewCourseName == "NA" ? "" : reviewCourseName}
                  disabled
                />
              </div>

              <div className="item3">
                <FormInputs
                  label="Subject"
                  type="text"
                  value={reviewSubjectName == "NA" ? "" : reviewSubjectName}
                  disabled
                />
              </div>

              <div className="item4">
                <FormInputs
                  label="HOD or Faculty Reviewer Group?"
                  type="text"
                  value={reviewerGroupType == "NA" ? "" : reviewerGroupType}
                  disabled
                />
              </div>

              <div className="item5">
                <FormInputs
                  label="Reviewer Level"
                  type="text"
                  value={
                    facultyReviewLevel == "NA" || facultyReviewLevel == "0"
                      ? ""
                      : String(facultyReviewLevel)
                  }
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MANAGE EMPLOYEE */}
      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header">
            <label>MANAGE EMPLOYEE</label>
          </div>
        </div>

        {/* CONTENT: header stays visible; content gets dimmed/disabled when group is inactive */}
        <div
          className="accordion-content"
          style={groupsLocked ? { opacity: 1 } : {}}
        >
          <div
            className="select-assign-test-container-ques-pap-del"
            style={{ padding: "20px 0px 20px 0px" }}
          >
            <div className="grid-container-ques-paper-del">
              <div className="item1" style={manageEmployeeContentStyle}>
                <DropdownWithPagination
                  label="Add Employees"
                  width="100%"
                  selected={selectedMembers}
                  setSelected={(vals) => {
                    setSelectedMembers(vals);
                  }}
                  onSearchInputChange={fetchEmployeesForGroupSearch}
                  options={memberOptions}
                  // isRequired={true}
                  showSelectAll={true}
                  itemsPerPage={4}
                  isDisabled={isDefaultGroup || groupsLocked} // disable when default or group locked
                />
              </div>

              <div
                style={{
                  gridColumn: "1 / -1",
                  marginTop: 16,
                  ...(groupsLocked ? { opacity: 0.45 } : {}),
                }}
              >
                <div style={groupsLocked ? { pointerEvents: "none" } : {}}>
                  <TableWithCrossStudentGroup
                    headers={tableHeaders}
                    data={tableData}
                    searchPlaceholder="Search employees..."
                    selectedRows={selectedMembers}
                    setSelectedRows={handleTableRowSelection}
                    renderQuestionText={(text) => text}
                    renderQuestionTextModel={(text) => text}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                    onRowLinkClick={(row) => console.log("Row clicked:", row)}
                    filterConfig={{}}
                    handleDeleteRow={handleDeleteRow} // will be no-op when default
                    isEditMode={!isDefaultGroup && !groupsLocked} // disable edits when default or locked
                    hideIdColumn={true} // hide first id column visually
                    disableHyperlink={true} // do not render the employee name as a hyperlink
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageGroupEmployee;
